import { render } from "./terms-and-services.html?vue&type=template&id=4538a259&scoped=true&lang=html&external"
import script from "./terms-and-services.vue?vue&type=script&lang=js"
export * from "./terms-and-services.vue?vue&type=script&lang=js"

import "./_terms-and-services.mobile.scss?vue&type=style&index=0&id=4538a259&lang=scss&scoped=true&external"
import "./_terms-and-services.desktop.scss?vue&type=style&index=1&id=4538a259&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4538a259"]])

export default __exports__